import { useContext, useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext, useAdminData } from "../../contexts/AuthContext";
import { Container,SideBarItemContainer, SideBarButton, CompanyInfoContainer, InternalContainer } from "./style";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faComputer,
    faRightFromBracket,
    faReceipt,
    faHome,
    faWarehouse,
    faTicket,
    faChartLine,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import { faPix, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { NavLink} from 'react-router-dom'
import helmet from '../../assets/icons/helmet.svg';

export function SideBar(){
    const { handleSignOut } = useContext(AuthContext);
    const { adminData } = useAdminData();
    const location = useLocation();

    const [isActive, setActive] = useState({
        dashboard:true,
        pedidoBalcao:false,
        ordensDeServico:false,
        produtos:false,
        categorias:false,
        pedidos:false,
        pedidosMenu: false,
        clientes:false,
        statistics:false,
        pix: false,
        configurations:false,
        administradores: false,
        pedidoOnline: false,
        aguardandoCliente: false,
        estoque: false,
        valoresAReceber: false,
        entregas: false,
        meusProdutos: false,
        generalCatalog: false,
        produtosPais: false,
        motoboys: false,
        cupon: false,
        relatorios: false,
        relatoriosMenu: false,
        produtosVendidos: false,
        segmentos: false
    })
    
    const handleActiveMenuButton = useCallback((name:string) => {
        switch(name){
            case 'dashboard':
                setActive({...isActive, 
                    'dashboard':true,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    'cupon': false,
                })
            break;
            case 'pedidoBalcao':
                setActive({...isActive, 
                    'dashboard':false,
                    'pedidoBalcao':true,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;
            case 'ordensDeServico':
            case 'aguardandoCliente':
            case 'pedidos':
                setActive({...isActive,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico': name === 'ordensDeServico',
                    'produtos':false,
                    'categorias':false,
                    'pedidos': name === 'pedidos',
                    'pedidosMenu': true,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    "pedidoOnline": false,
                    "aguardandoCliente": name === 'aguardandoCliente',
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;
            case 'statistics':
                setActive({...isActive, 
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':true,
                    "administradores": false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'clientes':
                setActive({...isActive,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':true,
                    'statistics':false,
                    "administradores": false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'administradores':
                setActive({...isActive,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": true,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'pix':
                setActive({...isActive, 
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': true,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'pedidoOnline':
                setActive({...isActive, 
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": true,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'produtos':
            case 'meus-produtos':
            case 'catalogo-geral':
            case 'produtos-online':
            case 'produtos-pais':
                setActive({...isActive, 
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':true,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "estoque": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "meusProdutos": false,
                    "generalCatalog": false,
                    "produtosPais": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'estoque':
                setActive({...isActive,
                    'estoque':true,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "valoresAReceber": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'valoresAReceber':
                setActive({...isActive,
                    'valoresAReceber':true,
                    'estoque':false,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'entregas':
                setActive({...isActive,
                    'valoresAReceber':false,
                    'estoque':false,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "entregas": true,
                    "motoboys": false,
                    "cupon": false
                })
            break;

            case 'motoboys':
                setActive({...isActive,
                    'valoresAReceber':false,
                    'estoque':false,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "entregas": false,
                    "motoboys": true,
                    "cupon": false
                })
            break;

            case 'cupon':
                setActive({...isActive,
                    'valoresAReceber':false,
                    'estoque':false,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": true,
                    "relatorios": false,
                    "relatoriosMenu": false
                })
            break;

            case 'relatorios':
            case 'relatorios/produtos':
            case 'produtosVendidos':
                setActive({...isActive,
                    'valoresAReceber':false,
                    'estoque':false,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false,
                    "relatorios": true,
                    "relatoriosMenu": true,
                    "produtosVendidos": name === 'relatorios/produtos' || name === 'produtosVendidos',
                    "segmentos": false
                })
            break;

            case 'segmentos':
            case 'datas-especiais':
                setActive({...isActive,
                    'valoresAReceber':false,
                    'estoque':false,
                    'dashboard':false,
                    'pedidoBalcao':false,
                    'ordensDeServico':false,
                    'produtos':false,
                    'categorias':false,
                    'pedidos':false,
                    'pedidosMenu': false,
                    'clientes':false,
                    'statistics':false,
                    "administradores": false,
                    'pix': false,
                    "pedidoOnline": false,
                    "aguardandoCliente": false,
                    "entregas": false,
                    "motoboys": false,
                    "cupon": false,
                    "relatorios": false,
                    "relatoriosMenu": false,
                    "segmentos": true
                })
            break;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const url = window.location.pathname;
        handleActiveMenuButton(url.replace("/", ""));
    }, [location.pathname, handleActiveMenuButton])
    // const chosenLogo = isMinimized ? logoMini : logoFull;

    return(
        <Container isMinimizedActive={true}>
            <InternalContainer isMinimizedActive={true}>
                <NavLink to="/backoffice/dashboard" style={{display: 'none'}}>
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('dashboard')}>
                        <SideBarButton
                            isActive={isActive['dashboard']}
                            isMinimizedActive
                        >
                            <FontAwesomeIcon icon={faHome} className="Side-Bar-Icon"/>
                            <span>Dashboard</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <NavLink to="/backoffice/pedidoBalcao">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('pedidoBalcao')}>
                        <SideBarButton
                            isActive={isActive['pedidoBalcao']}
                            isMinimizedActive
                            title="Novo Pedido"
                        >
                            <FontAwesomeIcon icon={faComputer} className="Side-Bar-Icon"/>
                            <span>Novo Pedido</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <NavLink to="/backoffice/pedidoOnline">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('pedidoOnline')}>
                        <SideBarButton
                            isActive={isActive['pedidoOnline']}
                            isMinimizedActive
                            title="Pedido Online"
                        >
                            <FontAwesomeIcon icon={faWhatsapp as any} className="Side-Bar-Icon"/>
                            <span>Pedido Online</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <SideBarItemContainer className="produtos-menu-container">
                    <SideBarButton
                        isActive={isActive['pedidosMenu']}
                        isMinimizedActive
                        title="Pedidos"
                    >
                        <FontAwesomeIcon icon={faReceipt} className="Side-Bar-Icon"/>
                        <span>Pedidos</span>
                    </SideBarButton>
                    <div className="submenu">
                        <NavLink to="/backoffice/ordensDeServico">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('ordensDeServico')}>
                                Pedidos Atuais
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/aguardandoCliente">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('aguardandoCliente')}>
                                Aguardando Cliente
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/pedidos">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('pedidos')}>
                                Pedidos Finalizados
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/painel" target="_blank" rel="noopener noreferrer">
                            <button className="submenu-item">
                                Painel da Loja (TV)
                            </button>
                        </NavLink>
                    </div>
                </SideBarItemContainer>

                <SideBarItemContainer className="produtos-menu-container">
                    <SideBarButton
                        isActive={isActive['produtos']}
                        isMinimizedActive
                        title="Produtos"
                    >
                        <i className="material-icons">local_florist</i>
                        <span>Produtos</span>
                    </SideBarButton>
                    <div className="submenu">
                        <NavLink to="/backoffice/meus-produtos">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('meus-produtos')}>
                                Meus Produtos
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/catalogo-geral">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('catalogo-geral')}>
                                Catálogo Geral
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/produtos-online">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('produtos-online')}>
                                Produtos Online
                            </button>
                        </NavLink>
                        {adminData.role === 'SYS_ADMIN' && (
                            <NavLink to="/backoffice/produtos-pais">
                                <button className="submenu-item" onClick={()=>handleActiveMenuButton('produtos-pais')}>
                                    Produtos Pais (SYS_ADMIN)
                                </button>
                            </NavLink>
                        )}
                    </div>
                </SideBarItemContainer>
                
                <NavLink to="/backoffice/estoque" style={{ display: 'none'}}>
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('estoque')}>
                        <SideBarButton
                            isActive={isActive['estoque']}
                            isMinimizedActive
                            title="Estoque"
                        >
                            <FontAwesomeIcon icon={faWarehouse} className="Side-Bar-Icon"/>
                            <span>Compras Efetuadas</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <NavLink to="/backoffice/estoque">
                    <SideBarItemContainer
                        onClick={() => handleActiveMenuButton('estoque')}
                    >
                        <SideBarButton
                            isActive={isActive['estoque']}
                            isMinimizedActive
                            title="Valores a Receber"
                        >
                            <FontAwesomeIcon icon={faWarehouse} className="Side-Bar-Icon"/>
                            <span>Estoque</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <NavLink to="/backoffice/valores-a-receber">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('valoresAReceber')}>
                        <SideBarButton
                            isActive={isActive['valoresAReceber']}
                            isMinimizedActive
                            title="Valores a Receber"
                        >
                            <i className="material-icons">account_balance_wallet</i>
                            <span>Ordens para receber</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>
                <NavLink to="/backoffice/cupons">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('cupon')}>
                        <SideBarButton
                            isActive={isActive['cupon']}
                            isMinimizedActive
                            title="Cupons"
                        >
                            <FontAwesomeIcon icon={faTicket} className="Side-Bar-Icon"/>
                            <span>Cupons</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>
                <SideBarItemContainer className="produtos-menu-container">
                    <SideBarButton
                        isActive={isActive['segmentos']}
                        isMinimizedActive
                        title="Campanhas"
                    >
                        <FontAwesomeIcon icon={faUsers} className="Side-Bar-Icon"/>
                        <span>Campanhas</span>
                    </SideBarButton>
                    <div className="submenu">
                        <NavLink to="/backoffice/segmentos">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('segmentos')}>
                                Segmentos de Clientes
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/datas-especiais">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('datas-especiais')}>
                                Datas Especiais
                            </button>
                        </NavLink>
                        <NavLink to="/backoffice/campanhas">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('segmentos')}>
                                Campanhas
                            </button>
                        </NavLink>
                        {adminData.role === 'SYS_ADMIN' && (
                            <NavLink to="/backoffice/whatsapp-templates">
                                <button className="submenu-item" onClick={()=>handleActiveMenuButton('segmentos')}>
                                    Templates (SYS_ADMIN)
                                </button>
                            </NavLink>
                        )}
                    </div>
                </SideBarItemContainer>
                <NavLink to="/backoffice/motoboys">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('motoboys')}>
                        <SideBarButton
                            isActive={isActive['motoboys']}
                            isMinimizedActive
                            title="Motoboys"
                        >
                            <i>
                                <img src={helmet} alt="Motoboys" style={{width: '20px', height: '20px'}}/>
                            </i>
                            <span>Motoboys</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>
                <NavLink to="/backoffice/entregas">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('entregas')}>
                        <SideBarButton
                            isActive={isActive['entregas']}
                            isMinimizedActive
                            title="Entregas"
                        >
                            <i className="material-icons">delivery_dining</i>
                            <span>Entregas</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <NavLink to="/backoffice/pix">
                    <SideBarItemContainer onClick={()=>handleActiveMenuButton('pix')}>
                        <SideBarButton
                            isActive={isActive['pix']}
                            isMinimizedActive
                            title="Pix Recebidos"
                        >
                            <FontAwesomeIcon icon={faPix as any} className="Side-Bar-Icon"/>
                            <span>Pix Recebidos</span>
                        </SideBarButton>
                    </SideBarItemContainer>
                </NavLink>

                <SideBarItemContainer className="produtos-menu-container">
                    <SideBarButton
                        isActive={isActive['relatoriosMenu']}
                        isMinimizedActive
                        title="Relatórios"
                    >
                        <FontAwesomeIcon icon={faChartLine} className="Side-Bar-Icon"/>
                        <span>Relatórios</span>
                    </SideBarButton>
                    <div className="submenu">
                        <NavLink to="/backoffice/relatorios/produtos">
                            <button className="submenu-item" onClick={()=>handleActiveMenuButton('relatorios/produtos')}>
                                Produtos Vendidos
                            </button>
                        </NavLink>
                    </div>
                </SideBarItemContainer>

                <CompanyInfoContainer
                    isMinimizedActive
                >

                <button className="custom-logout-button" onClick={handleSignOut}>
                    <FontAwesomeIcon icon={faRightFromBracket} className="custom-logout-icon" />
                    <span className="custom-logout-text">Sair</span>
                </button>
                </CompanyInfoContainer>
            </InternalContainer>
        </Container>
    )
}
